import "./App.css";
import { useState, useEffect } from "react";
import {
  Routes,
  Route,
  BrowserRouter,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { UserProvider } from "./util/context/user_context";
import ReactModal from "react-modal";
import { FixRequestProvider } from "util/context/fix_request_context";
import AppWithAuth from "app_with_auth";

function App() {
  // 배포 환경에서 console.log, console.warn 지우기
  if (process.env.NODE_ENV === "production") {
    console = window.console || {};
    console.log = function no_console() {};
    console.warn = function no_console() {};
    console.error = function () {};
  }

  // Modal root 설정
  ReactModal.setAppElement("#root");

  return (
    <div>
      <UserProvider>
        <FixRequestProvider>
          <AppWithAuth />
        </FixRequestProvider>
      </UserProvider>
    </div>
  );
}

export default App;
